import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IDownloadStrategy} from '@igp/shared/redux/download';

import {
    NegativeCarryoverReportDownloadClientStrategy,
    NegativeCarryoverReportDownloadServerStrategy,
    NegativeCarryoverWeeklySummaryDownloadClientStrategy,
    NegativeCarryoverWeeklySummaryDownloadServerStrategy,
} from './downloadStrategy';
import {NegativeCarryoverReportService, NegativeCarryoverWeeklySummaryService} from './service';
import {NegativeCarryoverReportServiceTypes, type NegativeCarryoverWeeklySummaryViewModelKeys} from './types';

export class NegativeCarryoverReportContainerFacade extends ContainerFacade {
    bindAll() {
        this._container.bind(NegativeCarryoverReportServiceTypes.Service).to(NegativeCarryoverReportService);
        this._container.bind(NegativeCarryoverReportServiceTypes.DownloadClientStrategy).to(NegativeCarryoverReportDownloadClientStrategy);
        this._container.bind(NegativeCarryoverReportServiceTypes.DownloadServerStrategy).to(NegativeCarryoverReportDownloadServerStrategy);
        this._container.bind(NegativeCarryoverReportServiceTypes.WeeklySummaryService).to(NegativeCarryoverWeeklySummaryService);
        this._container
            .bind<
                IDownloadStrategy<NegativeCarryoverWeeklySummaryViewModelKeys>
            >(NegativeCarryoverReportServiceTypes.WeeklySummaryDownloadClientStrategy)
            .to(NegativeCarryoverWeeklySummaryDownloadClientStrategy);
        this._container
            .bind<
                IDownloadStrategy<NegativeCarryoverWeeklySummaryViewModelKeys>
            >(NegativeCarryoverReportServiceTypes.WeeklySummaryDownloadServerStrategy)
            .to(NegativeCarryoverWeeklySummaryDownloadServerStrategy);
    }
}
